import React from 'react';
import type { ExtendedFormDefinition } from '@features/forms';

import type { Patient } from '../../types/types';
import { FormReviewAdapter } from '../patient-communication/FormReviewAdapter';

interface ReviewFormsSlidePaneProps {
  open: boolean;
  onClose: () => void;
  patient?: Patient;
  patientId: string;
  selectedFormIds: string[];
  forms?: ExtendedFormDefinition[];
  onSuccess?: () => void;
  /** Source for the form_sent analytics event (conversion attribution). */
  source?: string;
}

export const ReviewFormsSlidePane: React.FC<ReviewFormsSlidePaneProps> = ({
  open,
  onClose,
  patient,
  patientId,
  selectedFormIds,
  forms,
  onSuccess,
  source,
}) => {
  return (
    <FormReviewAdapter
      open={open}
      onClose={onClose}
      patient={patient}
      patientId={patientId}
      selectedFormIds={selectedFormIds}
      forms={forms}
      onSuccess={onSuccess}
      source={source}
    />
  );
};

export default ReviewFormsSlidePane;